<div class="page-content">

  <!-- HEADER -->
  <div class="page_header">
    <div class="page_header_text">
      <h1>{{ cliente?.nome ?? "A carregar..." }}</h1>
      <span *ngIf="cliente">NIF: {{ cliente.nif || "—" }}</span>
    </div>
    <div class="page_header_actions" *ngIf="cliente">
      <button class="btn-web-secondary" (click)="editarCliente()">
        <i class="fas fa-pencil-alt"></i> Editar Cliente
      </button>
    </div>
  </div>

  <!-- SKELETON -->
  <ng-container *ngIf="loadingCliente">
    <p-skeleton height="160px" styleClass="mb-4"></p-skeleton>
    <p-skeleton height="200px"></p-skeleton>
  </ng-container>

  <ng-container *ngIf="!loadingCliente && cliente">
    <!-- HERO CARD -->
    <div class="hero-card">
      <div class="hero-left">
        <div class="hero-av" [class.no-photo]="!cliente.logoUrl">
          <img *ngIf="cliente.logoUrl" [src]="cliente.logoUrl" [alt]="cliente.nome" class="hero-av-img"
            (error)="clearLogoUrl()" />
          <ng-container *ngIf="!cliente.logoUrl">
            <i class="fas fa-building av-icon"></i>
            <span class="av-lbl">Sem foto</span>
          </ng-container>
        </div>
        <div class="hero-info">
          <h2>{{ cliente.nome }}</h2>
          <div class="hero-tags">
            <!-- SECTOR BADGE -->
            <span 
              *ngIf="cliente.sector" 
              class="sector-badge" 
              [ngClass]="getSectorClass(cliente.sector)">
              <i class="fas fa-briefcase"></i>
              {{ getSectorLabel(cliente.sector) }}
            </span>
            <!-- STATUS BADGE -->
            <span 
              class="status-badge" 
              [ngClass]="cliente.IsActive !== false ? 'Activo' : 'Inactivo'">
              <i class="fas fa-circle"></i>
              {{ cliente.IsActive !== false ? "Activo" : "Inactivo" }}
            </span>
          </div>
          
          <div class="hero-contacts">
            <span *ngIf="cliente.numTelefone"><i class="fas fa-phone"></i> {{ cliente.numTelefone }}</span>
            <span *ngIf="cliente.email"><i class="fas fa-envelope"></i> {{ cliente.email }}</span>
            <span *ngIf="cliente.endereco"><i class="fas fa-map-marker-alt"></i> {{ cliente.endereco }}</span>
          </div>
        </div>
      </div>
      <div class="hero-kpis">
        <div class="hero-kpi">
          <span class="hk-val">{{ kpiContratosAtivos }}</span>
          <span class="hk-lbl">Contratos activos</span>
        </div>
        <div class="hero-kpi">
          <span class="hk-val">{{ kpiPostos }}</span>
          <span class="hk-lbl">Postos cobertos</span>
        </div>
        <div class="hero-kpi">
          <span class="hk-val">{{ kpiEfetivos }}</span>
          <span class="hk-lbl">Efetivos destacados</span>
        </div>
        <div class="hero-kpi warn">
          <span class="hk-val warn">{{ kpiOcorrenciasAbertas }}</span>
          <span class="hk-lbl">Ocorrências abertas</span>
        </div>
        <div class="hero-kpi valor" *ngIf="valorMensalAtual > 0">
          <span class="hk-val valor">{{ formatKz(valorMensalAtual) }}</span>
          <span class="hk-lbl">Valor mensal actual</span>
        </div>
      </div>
    </div>

    <!-- TABS -->
    <p-tabs [(value)]="activeTab">
      <p-tablist>
        <p-tab value="0"><i class="ri-information-line"></i> Visão Geral</p-tab>
        <p-tab value="1" (click)="loadContratos()">
          <i class="fas fa-file-invoice"></i> Contratos
          <span class="tab-badge" *ngIf="contratos.length">{{
            contratos.length
            }}</span>
        </p-tab>
        <p-tab value="2">
          <i class="ri-map-pin-2-line"></i> Postos
          <span class="tab-badge" *ngIf="_postosKpi.length">{{
            _postosKpi.length
            }}</span>
        </p-tab>
        <p-tab value="3" (click)="loadOcorrencias()">
          <i class="ri-alarm-warning-line"></i> Ocorrências
          <span class="tab-badge danger" *ngIf="ocorrencias.length">{{
            ocorrencias.length
            }}</span>
        </p-tab>
      </p-tablist>

      <!-- ── Tab 0: Visão Geral ─────────────────────────────────────── -->
      <p-tabpanel value="0">
        <div class="tab-grid">
          <div class="info-card">
            <div class="ic-header">
              <i class="fas fa-building"></i> Dados da Empresa
            </div>
            <div class="ic-body">
              <div class="ic-row">
                <span class="ic-key">Nome completo</span>
                <span class="ic-val">{{ cliente.nome }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">NIF Fiscal</span>
                <span class="ic-val mono">{{ cliente.nif || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Sector</span>
                <span class="ic-val">{{ getSectorLabel(cliente.sector) }}</span>
              </div>
              <div class="ic-row" *ngIf="cliente.website">
                <span class="ic-key">Website</span>
                <span class="ic-val"><i class="ri-external-link-line"></i>
                  {{ cliente.website }}</span>
              </div>
            </div>
          </div>

          <div class="info-card">
            <div class="ic-header">
              <i class="ri-contacts-line"></i> Contactos
            </div>
            <div class="ic-body">
              <div class="ic-row">
                <span class="ic-key">Responsável</span>
                <span class="ic-val"><i class="fas fa-user-shield"></i>
                  {{ cliente.nomeResponsavel || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">Telefone</span>
                <span class="ic-val"><i class="fas fa-phone"></i>
                  {{ cliente.numTelefone || "—" }}</span>
              </div>
              <div class="ic-row">
                <span class="ic-key">E-mail</span>
                <span class="ic-val"><i class="fas fa-envelope"></i> {{ cliente.email || "—" }}</span>
              </div>
              <div class="ic-row" *ngIf="cliente.endereco">
                <span class="ic-key">Endereço</span>
                <span class="ic-val"><i class="fas fa-map-marker-alt"></i> {{ cliente.endereco }}</span>
              </div>
            </div>
          </div>

          <div class="info-card summary-card">
            <div class="ic-header">
              <i class="fas fa-shield-alt"></i> Resumo do Serviço
            </div>
            <div class="summary-stats">
              <div class="ss-item">
                <i class="fas fa-file-invoice ss-icon blue"></i>
                <div>
                  <span class="ss-val">{{ kpiContratosAtivos }}</span>
                  <span class="ss-lbl">Contrato{{ kpiContratosAtivos !== 1 ? "s" : "" }} activo{{
                    kpiContratosAtivos !== 1 ? "s" : ""
                    }}</span>
                </div>
              </div>
              <div class="ss-item">
                <i class="ri-map-pin-2-line ss-icon green"></i>
                <div>
                  <span class="ss-val">{{ kpiPostos }}</span>
                  <span class="ss-lbl">Posto{{ kpiPostos !== 1 ? "s" : "" }} em cobertura</span>
                </div>
              </div>
              <div class="ss-item">
                <i class="ri-team-line ss-icon purple"></i>
                <div>
                  <span class="ss-val">{{ kpiEfetivos }}</span>
                  <span class="ss-lbl">Efetivo{{ kpiEfetivos !== 1 ? "s" : "" }} por turno</span>
                </div>
              </div>
              <div class="ss-item">
                <i class="fas fa-dollar-sign ss-icon yellow"></i>
                <div>
                  <span class="ss-val">{{ formatKz(valorMensalAtual) }}</span>
                  <span class="ss-lbl">Valor mensal</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabpanel>

      <!-- ── Tab 1: Contratos ──────────────────────────────────────── -->
      <p-tabpanel value="1">
        <div class="tab-action-bar">
          <button class="btn-success btn-sm" (click)="novoContrato()">
            <i class="ri-file-add-line"></i> Novo Contrato
          </button>
        </div>
        <div *ngIf="loadingContratos" class="skeleton-rows">
          <p-skeleton height="64px" *ngFor="let i of [1, 2, 3]" styleClass="mb-2"></p-skeleton>
        </div>
        <app-empty-state *ngIf="!loadingContratos && contratos.length === 0" icon="fas fa-file-invoice"
          title="Sem contratos registados" message="Nenhum contrato associado a este cliente."
          actionLabel="Novo Contrato" (action)="novoContrato()">
        </app-empty-state>
        <div class="contratos-list" *ngIf="!loadingContratos && contratos.length > 0">
          <article class="contrato-card" *ngFor="let c of contratos">
            <div class="cc-header">
              <div class="cc-identity">
                <div class="cc-icon"><i class="ri-file-shield-2-line"></i></div>
                <div class="cc-heading">
                  <div class="cc-title-row">
                    <h3 class="cc-title">Contrato #{{ c.id }}</h3>
                    <span class="badge" [ngClass]="getContratoClass(c)">
                      {{ getContratoEstado(c) }}
                    </span>
                  </div>
                  <span class="cc-service">{{
                    c.tipoServicoDescricao ?? "—"
                  }}</span>
                </div>
              </div>
              <div class="cc-actions" (click)="$event.stopPropagation()">
                <div class="kebab-menu" [class.open]="openMenuId === c.id">
                  <button
                    class="btn-icon kebab-trigger"
                    (click)="toggleMenu(c.id, $event)"
                    pTooltip="Acções"
                    tooltipPosition="top"
                  >
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <div class="kebab-dropdown" *ngIf="openMenuId === c.id">
                    <button
                      class="kd-item"
                      (click)="editarContrato(c); openMenuId = null"
                    >
                      <i class="fas fa-pencil-alt"></i> Editar
                    </button>
                    <button
                      class="kd-item danger"
                      (click)="eliminarContrato(c); openMenuId = null"
                    >
                      <i class="fas fa-trash-alt"></i> Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="cc-meta">
              <div class="cc-meta-item">
                <span class="cc-meta-lbl">Modelo de Cobrança</span>
                <span class="cc-meta-val">{{
                  c.modeloCobrancaDescricao ?? "—"
                }}</span>
              </div>
              <div class="cc-meta-item">
                <span class="cc-meta-lbl">Data de Validade</span>
                <span class="cc-meta-val">{{ formatDate(c.fimContrato) }}</span>
              </div>
              <div class="cc-meta-item">
                <span class="cc-meta-lbl">Início do Contrato</span>
                <span class="cc-meta-val">{{ formatDate(c.inicioContrato) }}</span>
              </div>
            </div>

            <div class="cc-finance">
              <div class="cc-money">
                <span class="cc-money-lbl">Valor Mensal</span>
                <strong class="cc-money-val">{{
                  formatKz(c.valorMensal)
                }}</strong>
                <span class="cc-formula">{{ getContratoFormula(c) }}</span>
              </div>
              <div class="cc-money cc-money--annual">
                <span class="cc-money-lbl">Valor Anual Estimado</span>
                <strong class="cc-money-val">{{
                  formatKz(getValorAnualContrato(c))
                }}</strong>
                <span class="cc-formula">12 × valor mensal</span>
              </div>
            </div>

            <div class="cc-details" *ngIf="getContratoDetalhes(c).length">
              <div class="cc-detail" *ngFor="let d of getContratoDetalhes(c)">
                <span class="cc-detail-lbl">{{ d.label }}</span>
                <span class="cc-detail-val">{{ d.value }}</span>
              </div>
            </div>
          </article>
        </div>
      </p-tabpanel>

      <!-- ── Tab 2: Postos ─────────────────────────────────────────── -->
      <p-tabpanel value="2">
        <app-postos-listagem [idCliente]="clienteId" [compacto]="true" mapaHeight="480px"
          (verPosto)="navegarParaPosto($event)" (editarPosto)="openEdit($event)"
          (novoPosto)="criarPostoParaCliente({})">
        </app-postos-listagem>
      </p-tabpanel>

      <!-- ── Tab 3: Ocorrências ─────────────────────────────────────── -->
      <p-tabpanel value="3">
        <div *ngIf="loadingOcorrencias" class="skeleton-rows">
          <p-skeleton height="48px" *ngFor="let i of [1, 2, 3]" styleClass="mb-2"></p-skeleton>
        </div>
        <app-empty-state *ngIf="!loadingOcorrencias && ocorrencias.length === 0" icon="ri-alarm-warning-line"
          title="Sem ocorrências registadas">
        </app-empty-state>
        <div class="data-table-wrapper" *ngIf="!loadingOcorrencias && ocorrencias.length > 0">
          <table class="data-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Tipo</th>
                <th>Criticidade</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of ocorrencias">
                <td class="mono" style="white-space: nowrap">
                  {{ formatDate(o.dataOcorrencia) }}
                </td>
                <td>{{ getTipoLabel(o.tipoOcorrencia) }}</td>
                <td>
                  <span class="crit-badge" [ngClass]="getCritClass(o.criticidade)">
                    {{ getCritLabel(o.criticidade) }}
                  </span>
                </td>
                <td class="desc-cell">{{ o.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </p-tabpanel>

    </p-tabs>
  </ng-container>

  <!-- ───── DRAWER: ANEXAR DOCUMENTO ───── -->
  <input #uploadFileInput type="file" hidden (change)="onUploadFileChange($event)" />

  <p-drawer header="Anexar Documento" [(visible)]="showUploadDialog" position="right" [modal]="true"
    [style]="{ width: '480px' }" styleClass="efetivo-drawer-dark">
    <div class="upload-form">
      <div class="form-group">
        <label>Designação <span class="req">*</span></label>
        <input class="form-input" [(ngModel)]="uploadDesignacao" placeholder="Ex: Contrato 2025, Proposta..." />
      </div>

      <div class="form-group">
        <label>Ficheiro <span class="req">*</span></label>
        <div class="upload-drop" (click)="triggerUploadInput()">
          <ng-container *ngIf="!uploadFile">
            <i class="fas fa-cloud-upload-alt"></i>
            <span>Clique para seleccionar ficheiro</span>
            <small>PDF, Word, Excel, imagens</small>
          </ng-container>
          <ng-container *ngIf="uploadFile">
            <i class="fas fa-file-signature"></i>
            <span>{{ uploadFile.name }}</span>
            <small>{{ formatBytes(uploadFile.size) }}</small>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer-actions">
        <button class="btn-web-secondary" (click)="showUploadDialog = false">
          Cancelar
        </button>
        <button class="btn-web-primary" (click)="upload()" [disabled]="uploading">
          <i [class]="uploading ? 'fas fa-spinner fa-spin' : 'ri-upload-2-line'"></i>
          {{ uploading ? "A enviar..." : "Guardar" }}
        </button>
      </div>
    </ng-template>
  </p-drawer>

  <!-- ───── DRAWER: CONTRATO ───── -->
  <input #contratoFileInput type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,image/*" hidden
    (change)="onContratoFileChange($event)" />

  <p-drawer [header]="
      editingContrato
        ? 'Editar Contrato #' + editingContrato.id
        : 'Novo Contrato'
    " [(visible)]="showContratoDialog" position="right" [modal]="true" [style]="{ width: '640px' }"
    styleClass="efetivo-drawer-dark">
    <form *ngIf="contratoForm" [formGroup]="contratoForm" class="dialog-form cd-form">
      <p class="form-section-title">
        <i class="fas fa-coins"></i> Condições Financeiras
      </p>

      <div class="form-group cd-tipo-servico">
        <label>Tipo de Serviço <span class="req">*</span></label>
        <p-select formControlName="tipoServico" [options]="tiposServico"
          optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de serviço"
          styleClass="w-full" appendTo="body">
        </p-select>
        <span class="sp-error" *ngIf="cf['tipoServico'].invalid && cf['tipoServico'].touched">
          Campo obrigatório
        </span>
      </div>

      <div class="form-group">
        <label>Modelo de Cobrança <span class="req">*</span></label>
        <p-select formControlName="modeloCobranca" [options]="modeloCobrancas"
          optionLabel="label" optionValue="value" placeholder="Seleccionar modelo"
          styleClass="w-full" appendTo="body" (onChange)="onModeloChange($event)">
        </p-select>
      </div>

      <ng-container [ngSwitch]="modeloCobranca">
        <!-- FIXO MENSAL -->
        <ng-container *ngSwitchCase="'fixo_mensal'">
          <div class="form-grid-2 cd-billing-fields">
            <div class="form-group">
              <label>Valor Mensal (Kz) <span class="req">*</span></label>
              <p-inputNumber formControlName="valorMensal" [min]="0" [useGrouping]="true" placeholder="Ex: 5 000 000"
                styleClass="w-full form-inputnumber" suffix=" Kz">
              </p-inputNumber>
            </div>
            <div class="form-group">
              <label>Nº de Postos</label>
              <p-inputNumber formControlName="numPostos" [min]="0" styleClass="w-full form-inputnumber">
              </p-inputNumber>
            </div>
          </div>
          <div class="cd-finance-preview" *ngIf="(cf['valorMensal'].value || 0) > 0">
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="ri-calendar-line"></i> Valor Mensal</span>
              <span class="cd-fp-val">{{ formatKz(cf['valorMensal'].value) }}</span>
            </div>
            <div class="cd-fp-sep"></div>
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
              <span class="cd-fp-val strong">{{ formatKz((cf['valorMensal'].value || 0) * 12) }}</span>
            </div>
          </div>
        </ng-container>

        <!-- POR EFETIVO -->
        <ng-container *ngSwitchCase="'por_efetivo'">
          <div class="form-grid-2 cd-billing-fields">
            <div class="form-group">
              <label>Valor unitário (Kz) <span class="req">*</span></label>
              <p-inputNumber formControlName="valorUnitario" [min]="0" [useGrouping]="true" placeholder="Ex: 50 000"
                styleClass="w-full form-inputnumber" suffix=" Kz">
              </p-inputNumber>
            </div>
            <div class="form-group">
              <label>Nº de efectivos <span class="req">*</span></label>
              <p-inputNumber formControlName="numEfetivos" [min]="0" styleClass="w-full form-inputnumber">
              </p-inputNumber>
            </div>
          </div>
          <div class="cd-finance-preview" *ngIf="totalMensalCalculado > 0">
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
              <span class="cd-fp-val strong">{{ formatKz(totalMensalCalculado) }}</span>
            </div>
            <div class="cd-fp-sep"></div>
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
              <span class="cd-fp-val">{{ formatKz(totalMensalCalculado * 12) }}</span>
            </div>
          </div>
        </ng-container>

        <!-- POR POSTO -->
        <ng-container *ngSwitchCase="'por_posto'">
          <div class="form-grid-2 cd-billing-fields">
            <div class="form-group">
              <label>Valor unitário (Kz) <span class="req">*</span></label>
              <p-inputNumber formControlName="valorUnitario" [min]="0" [useGrouping]="true" placeholder="Ex: 200 000"
                styleClass="w-full form-inputnumber" suffix=" Kz">
              </p-inputNumber>
            </div>
            <div class="form-group">
              <label>Nº de postos <span class="req">*</span></label>
              <p-inputNumber formControlName="numPostos" [min]="0" styleClass="w-full form-inputnumber">
              </p-inputNumber>
            </div>
          </div>
          <div class="cd-finance-preview" *ngIf="totalMensalCalculado > 0">
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
              <span class="cd-fp-val strong">{{ formatKz(totalMensalCalculado) }}</span>
            </div>
            <div class="cd-fp-sep"></div>
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
              <span class="cd-fp-val">{{ formatKz(totalMensalCalculado * 12) }}</span>
            </div>
          </div>
        </ng-container>

        <!-- POR HORA -->
        <ng-container *ngSwitchCase="'por_hora'">
          <div class="form-grid-2 cd-billing-fields">
            <div class="form-group">
              <label>Valor por hora (Kz) <span class="req">*</span></label>
              <p-inputNumber formControlName="valorUnitario" [min]="0" [useGrouping]="true" placeholder="Ex: 5 000"
                styleClass="w-full form-inputnumber" suffix=" Kz">
              </p-inputNumber>
            </div>
            <div class="form-group">
              <label>Nº de horas / mês <span class="req">*</span></label>
              <p-inputNumber formControlName="numHoras" [min]="0" styleClass="w-full form-inputnumber">
              </p-inputNumber>
            </div>
          </div>
          <div class="cd-finance-preview" *ngIf="totalMensalCalculado > 0">
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="ri-calendar-line"></i> Total Mensal</span>
              <span class="cd-fp-val strong">{{ formatKz(totalMensalCalculado) }}</span>
            </div>
            <div class="cd-fp-sep"></div>
            <div class="cd-fp-item">
              <span class="cd-fp-lbl"><i class="fas fa-calendar-alt"></i> Valor Anual Estimado</span>
              <span class="cd-fp-val">{{ formatKz(totalMensalCalculado * 12) }}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <span class="sp-error" *ngIf="contratoForm.hasError('modeloIncompleto') && contratoForm.touched">
        <i class="fas fa-exclamation-triangle"></i> Preencha correctamente os valores do modelo de cobrança seleccionado
      </span>

      <div class="form-divider"></div>

      <p class="form-section-title">
        <i class="fas fa-calendar-alt"></i> Período do Contrato
      </p>
      <div class="cd-grid-3">
        <div class="form-group">
          <label>Data de Início <span class="req">*</span></label>
          <p-datepicker [showIcon]="true" formControlName="inicioContrato" dateFormat="dd/mm/yy"
            placeholder="dd/mm/aaaa" styleClass="w-full" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel">
          </p-datepicker>
          <span class="sp-error" *ngIf="cf['inicioContrato'].invalid && cf['inicioContrato'].touched">
            <i class="fas fa-exclamation-triangle"></i> Campo obrigatório
          </span>
        </div>
        <div class="form-group">
          <label>Data de Fim <span class="req">*</span></label>
          <p-datepicker [showIcon]="true" formControlName="fimContrato" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa"
            styleClass="w-full" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel">
          </p-datepicker>
          <span class="sp-error" *ngIf="cf['fimContrato'].invalid && cf['fimContrato'].touched">
            <i class="fas fa-exclamation-triangle"></i> Campo obrigatório
          </span>
        </div>
        <div class="form-group">
          <label>Data de Facturação</label>
          <p-datepicker [showIcon]="true" formControlName="dataFaturacao" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa"
            styleClass="w-full" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel">
          </p-datepicker>
        </div>
      </div>

      <span class="sp-error" *ngIf="
          contratoForm.hasError('fimAnterior') && cf['fimContrato'].touched
        ">
        <i class="fas fa-exclamation-triangle"></i> A data de fim deve ser posterior à data de início
      </span>

      <div class="cd-duracao-pill" *ngIf="contratoDuracaoMeses > 0">
        <i class="fas fa-calendar-check"></i>
        Duração:
        <strong>{{ contratoDuracaoMeses }} mes{{
          contratoDuracaoMeses !== 1 ? "es" : ""
          }}</strong>
      </div>

      <div class="form-divider"></div>

      <p class="form-section-title">
        <i class="fas fa-file-invoice"></i> Documento do Contrato
        <span class="cd-opt">opcional</span>
      </p>

      <div class="cd-upload-zone" (click)="triggerContratoFileInput()" [class.has-file]="contratoFile">
        <ng-container *ngIf="!contratoFile">
          <div class="cd-uz-icon"><i class="fas fa-cloud-upload-alt"></i></div>
          <div class="cd-uz-text">
            <span>Clique para anexar o documento</span>
            <small>PDF, Word, Excel ou imagem</small>
          </div>
        </ng-container>
        <ng-container *ngIf="contratoFile">
          <div class="cd-uz-icon file"><i class="fas fa-file-signature"></i></div>
          <div class="cd-uz-text">
            <span>{{ contratoFile.name }}</span>
            <small>{{ formatBytes(contratoFile.size) }}</small>
          </div>
          <button type="button" class="cd-uz-remove" (click)="removeContratoFile($event)" pTooltip="Remover ficheiro"
            tooltipPosition="top">
            <i class="fas fa-times"></i>
          </button>
        </ng-container>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button class="btn-web-secondary" (click)="showContratoDialog = false">
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="saveContrato()" [disabled]="savingContrato">
        <i [class]="savingContrato ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        {{ savingContrato ? "A guardar..." : "Guardar" }}
      </button>
    </ng-template>
  </p-drawer>

  <!-- ───── DRAWER: EDITAR CLIENTE ───── -->
  <input #editFileInput type="file" accept="image/*" hidden (change)="onLogoChange($event)" />

  <p-drawer header="Editar Cliente" [(visible)]="showEditDialog" position="right" [modal]="true"
    [style]="{ width: '720px' }" styleClass="efetivo-drawer-dark">
    <form *ngIf="editForm" [formGroup]="editForm" class="dialog-form">
      <p class="form-section-title">
        <i class="fas fa-building"></i> Dados da Empresa / Cliente
      </p>

      <div class="form-top-row">
        <div class="logo-zone" (click)="triggerLogoInput()" pTooltip="Clique para alterar logotipo" tooltipPosition="right">
          <img *ngIf="logoPreview" [src]="logoPreview" class="logo-img" alt="Logotipo" />
          <div *ngIf="!logoPreview" class="logo-empty">
            <i class="ri-image-add-line"></i>
            <span>Logotipo</span>
          </div>
          <div class="logo-overlay">
            <i class="ri-camera-line"></i>
          </div>
        </div>

        <div class="form-ident">
          <div class="form-group">
            <label>Nome da Empresa / Cliente <span class="req">*</span></label>
            <input class="form-input" formControlName="nome" placeholder="Ex: Banco BFA, S.A." />
            <span class="sp-error" *ngIf="editForm.get('nome')?.invalid && editForm.get('nome')?.touched">
              Campo obrigatório
            </span>
          </div>

          <div class="form-group">
            <label>NIF Fiscal</label>
            <div class="nif-search-row">
              <input class="form-input" formControlName="nif" placeholder="Ex: 5410003691" />
              <button type="button" class="btn-nif" (click)="searchNif()" [disabled]="nifSearching" pTooltip="Pesquisar empresa pelo NIF" tooltipPosition="top">
                <i [class]="nifSearching ? 'fas fa-spinner fa-spin' : 'fas fa-search'"></i>
                {{ nifSearching ? "A pesquisar..." : "Pesquisar NIF" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-divider"></div>

      <p class="form-section-title">
        <i class="fas fa-briefcase"></i> Informação Comercial
      </p>

      <div class="form-grid-2">
        <div class="form-group">
          <label>Sector de Actividade</label>
          <p-select formControlName="sector" [options]="sectors" optionLabel="label" optionValue="value" placeholder="Seleccionar sector" styleClass="w-full" appendTo="body">
          </p-select>
        </div>

        <div class="form-group">
          <label>Website</label>
          <div class="input-prefix-wrap">
            <span class="input-prefix"><i class="fas fa-globe"></i></span>
            <input class="form-input prefixed" formControlName="website" placeholder="www.empresa.ao" />
          </div>
        </div>
      </div>

      <div class="form-divider"></div>

      <p class="form-section-title">
        <i class="ri-contacts-line"></i> Informação de Contacto
      </p>

      <div class="form-grid-2">
        <div class="form-group">
          <label>Telefone</label>
          <div class="input-prefix-wrap">
            <span class="input-prefix"><i class="fas fa-phone"></i></span>
            <input class="form-input prefixed" type="tel" formControlName="numTelefone" placeholder="923 000 000" (input)="formatPhone($event)" />
          </div>
        </div>

        <div class="form-group">
          <label>E-mail</label>
          <div class="input-prefix-wrap">
            <span class="input-prefix"><i class="fas fa-envelope"></i></span>
            <input class="form-input prefixed" formControlName="email" placeholder="geral@empresa.ao" />
          </div>
        </div>

        <div class="form-group">
          <label>Nome do Responsável</label>
          <div class="input-prefix-wrap">
            <span class="input-prefix"><i class="fas fa-user-shield"></i></span>
            <input class="form-input prefixed" formControlName="nomeResponsavel" placeholder="Nome completo" />
          </div>
        </div>

        <div class="form-group">
          <label>Endereço</label>
          <div class="input-prefix-wrap">
            <span class="input-prefix"><i class="fas fa-map-marker-alt"></i></span>
            <input class="form-input prefixed" formControlName="endereco" placeholder="Rua, nº, município" />
          </div>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button class="btn-web-secondary" (click)="showEditDialog = false">
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="saveEdit()" [disabled]="savingEdit">
        <i [class]="savingEdit ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        {{ savingEdit ? "A guardar..." : "Guardar Alterações" }}
      </button>
    </ng-template>
  </p-drawer>
</div>